import React from 'react';
import { INPUT_MAP } from './form.config';

import { FORM_KEYS } from './form.keys';
import { FixedRatios, RatioSelectorOptions } from '@model';

const flexStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const checkBoxStyle = {
  ...flexStyle,
  maxHeight: '6rem',
};

export const columns = [
  {
    title: (
      <div className="col-title">
        <span />
      </div>
    ),
    dataIndex: FORM_KEYS.DRAG.key,
    key: FORM_KEYS.DRAG.key,
    style: { ...checkBoxStyle, width: '3rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
  },
  {
    title: (
      <div className="col-title left pl15">
        <span className="is-required">{FORM_KEYS.MODULE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.MODULE.key,
    key: FORM_KEYS.MODULE.key,
    style: { width: '15rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.MODULE.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.TYPE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.TYPE.key,
    key: FORM_KEYS.TYPE.key,
    style: { ...checkBoxStyle, width: '7rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.TYPE.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.DISPLAY.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.DISPLAY.key,
    key: FORM_KEYS.DISPLAY.key,
    style: { ...checkBoxStyle, width: '5rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DISPLAY.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.IFRAME.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.IFRAME.key,
    key: FORM_KEYS.IFRAME.key,
    style: { ...checkBoxStyle, width: '5rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.IFRAME.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.COLOR.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.COLOR.key,
    key: FORM_KEYS.COLOR.key,
    style: { width: '6.875rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.COLOR.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>Ratio</span>
      </div>
    ),
    dataIndex: 'ratio',
    key: 'ratio',
    style: { ...checkBoxStyle, width: '12.5rem' },
    formConfig: {
      ...INPUT_MAP[FORM_KEYS.RATIO.key],
      // disabled: isDefault,
      options: RatioSelectorOptions,
      defaultValue: FixedRatios.FULL,
      className: 'section-ratio-select',
      shouldRefRowData: true,
    },
  },
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.LINK.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.LINK.key,
    key: FORM_KEYS.LINK.key,
    style: { width: '10.875rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.LINK.key] },

    //
  },
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.DES.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.DES.key,
    key: FORM_KEYS.DES.key,
    formConfig: {
      ...INPUT_MAP[FORM_KEYS.DES.key],
      maxLength: 999,
      rules: [
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (value?.length > 180) {
              return Promise.reject(
                new Error('Exceeds maximum characters allowed!'),
              );
            }
            return Promise.resolve();
          },
        }),
      ],
    },
    style: { flexShrink: 1 },
  },
  {
    dataIndex: FORM_KEYS.DELETE.key,
    key: FORM_KEYS.DELETE.key,
    style: {
      ...flexStyle,
      width: '1.5rem',
      paddingLeft: 0,
      paddingRight: 0,
    },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },

    //
  },
];

export const getDefaultRowData = (data = {}) => ({
  [FORM_KEYS.COLOR.key]: 'yellow',
  [FORM_KEYS.DISPLAY.key]: true,
  [FORM_KEYS.IFRAME.key]: false,
  type: 'text',
  ...data,
});
